import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useHistory } from 'react-router-dom';
import EditorComponent from 'components/base/EditorComponent';
import { WordCount, checkWordCount } from 'components/base/WordCount';
import { CommonWrapper } from 'components/company/CompanyFulltime';
import { handleFieldError, moveToFirstError } from 'libs/api/errorHandle';
import { recruitmentCreate } from 'libs/api/main';
import { TRecruitment } from 'modules/main';
import { CDateTimeFormat, CDefaultDateFormat } from 'constants/base.const';
import { CWindowWidth } from 'constants/base.const';
import { ERecruitmentCategory } from 'enums/base.enum';
import { EMentoringField } from 'enums/mentoring.enum';
import { ERoute } from 'enums/route.enum';
import { Tabs, Col, Row, Typography, Form, Radio, Input, Button, DatePicker } from 'antd';
import styled from 'styled-components';
import { FormWrapper, SecondaryColor } from 'GlobalStyles';

const { TabPane } = Tabs;
const { Text, Title } = Typography;
const CompanyJobOpeningWrapper = styled.div`
  padding: 0px 10px;
  .ant-form-item {
    margin-bottom: 16px;
  }
`;

const CompanyJobOpening = () => {
  const [submitButtonDisabled, setSubmitButtonDisabled] = useState(false);
  const [form] = Form.useForm();
  const history = useHistory();
  const [category, setCategory] = useState(ERecruitmentCategory.Fulltime);

  const onClickSubmit = () => {
    form
      .validateFields()
      .then((value) => {
        handleSubmit(value as TRecruitment);
      })
      .catch((errorInfo) => {
        moveToFirstError(form, errorInfo.errorFields);
      });
  };

  const handleSubmit = async (value: TRecruitment) => {
    try {
      setSubmitButtonDisabled(true);
      const response = await recruitmentCreate(value);
      history.push({
        pathname:
          value.category === ERecruitmentCategory.Fulltime ? ERoute.CompanyFulltime : ERoute.CompanyParttime,
        // state: {
        //   notification: {
        //     type: ENotificationType.Success,
        //     message: '채용공고가 등록되었습니다. 관리자 검토 후 글이 게시됩니다.'
        //   }
        // },
      });
    } catch (e) {
      handleFieldError(e, form);
      throw e;
    } finally {
      setSubmitButtonDisabled(false);
    }
  };

  return (
    <CommonWrapper>
      <Helmet>
        <title>채용공고 등록</title>
      </Helmet>
      <div className='title_wrapper'>
        <Title>채용공고 등록</Title>
        <Text style={{ marginTop: '10px' }}>
          Career Step 내 우수한 Candidates에게 회사 채용 공고를 알려주세요.
        </Text>
      </div>
      <CompanyJobOpeningWrapper>
        <Row
          style={{
            maxWidth: `${CWindowWidth - 300}px`,
            margin: '20px auto',
            padding: '0px',
          }}
          gutter={[0, 16]}
        >
          <Col xs={24} sm={24} md={8} lg={8} xl={8}>
            <Title style={{ marginTop: '30px', marginBottom: '30px' }} level={2}>
              채용공고를 등록하시고
              <br />
              우수한 직원을
              <br />
              채용하세요.
            </Title>
          </Col>
          <Col xs={24} sm={24} md={16} lg={16} xl={16}>
            <FormWrapper>
              <Form
                form={form}
                name='Recruitment'
                layout='vertical'
                initialValues={{
                  category: ERecruitmentCategory.Fulltime,
                  mentoring_field: EMentoringField.Consulting,
                }}
                className='form-normal with-required'
              >
                <Form.Item
                  name={'mentoring_field'}
                  label='분야'
                  className='form-item form-item-fit-content'
                  rules={[{ required: true }]}
                >
                  <Radio.Group className='col-8'>
                    <Radio.Button value={EMentoringField.Consulting}>Consulting</Radio.Button>
                    <Radio.Button value={EMentoringField.Finance}>Finance</Radio.Button>
                    <Radio.Button value={EMentoringField.Tech}>Tech</Radio.Button>
                  </Radio.Group>
                </Form.Item>
                <Form.Item
                  name={'category'}
                  label='카테고리'
                  className='form-item form-item-fit-content'
                  rules={[{ required: true }]}
                >
                  <Radio.Group className='col-12' onChange={(e) => setCategory(e.target.value)}>
                    <Radio.Button value={ERecruitmentCategory.Fulltime}>정규직</Radio.Button>
                    <Radio.Button value={ERecruitmentCategory.Parttime}>인턴</Radio.Button>
                  </Radio.Group>
                </Form.Item>
                <Form.Item
                  name={'company_name'}
                  className='form-item'
                  label='회사명'
                  rules={[{ required: true }]}
                >
                  <Input size='large' placeholder='회사명을 입력해 주세요. 최대 20자.' maxLength={20} />
                </Form.Item>
                <Form.Item
                  name={'title'}
                  className='form-item'
                  label='공고 제목'
                  rules={[{ required: true }]}
                >
                  <Input size='large' placeholder='공고 제목을 입력해 주세요' />
                </Form.Item>
                {category === ERecruitmentCategory.Fulltime && (
                  <Input.Group>
                    <div style={{ marginBottom: '10px', width: '100%' }}>
                      <Form.Item name={'position'} className='form-item no-margin' label='채용 직급'>
                        <Input
                          name='position'
                          size='large'
                          placeholder='(ex) Associate'
                          maxLength={100}
                          onChange={checkWordCount}
                        />
                      </Form.Item>
                      <WordCount target='position' maxCount={100} />
                    </div>
                    <div style={{ marginTop: '20px', width: '100%' }}>
                      <Row justify='space-between' gutter={[8, 0]}>
                        <Col span={12}>
                          <Form.Item
                            name={'recruitment_from'}
                            className='form-item form-inline'
                            label='서류 제출 기한'
                            rules={[{ required: true }]}
                          >
                            <DatePicker showTime format={CDateTimeFormat} placeholder='시작일' />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item name={'recruitment_to'} className='form-item form-inline' label=' '>
                            <DatePicker showTime format={CDateTimeFormat} placeholder='종료일(서류 마감일)' />
                          </Form.Item>
                          <span
                            style={{
                              marginTop: '-10px',
                              float: 'right',
                              fontSize: '12px',
                              color: `${SecondaryColor}`,
                            }}
                          >
                            종료일을 비워두면 ASAP로 표시됩니다
                          </span>
                        </Col>
                      </Row>
                    </div>
                  </Input.Group>
                )}
                {category === ERecruitmentCategory.Parttime && (
                  <Input.Group>
                    <Row gutter={[16, 0]}>
                      <Col span={12}>
                        <Form.Item
                          name={'employment_from'}
                          className='form-item form-inline required'
                          label='근무 기간'
                        >
                          <DatePicker format={CDefaultDateFormat} placeholder='시작일' />
                        </Form.Item>
                        <span
                          style={{
                            marginTop: '-10px',
                            float: 'right',
                            fontSize: '12px',
                            color: `${SecondaryColor}`,
                          }}
                        >
                          시작일을 비워두면 ASAP로 표시됩니다
                        </span>
                      </Col>
                      <Col span={12}>
                        <Form.Item
                          name={'employment_to'}
                          className='form-item form-inline required-none'
                          label=' '
                          rules={[{ required: true }]}
                        >
                          <DatePicker format={CDefaultDateFormat} placeholder='종료일' />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row gutter={[16, 0]}>
                      <Col span={8}>
                        <Form.Item
                          name={'responsible_name'}
                          className='form-item'
                          label='담당자 연락처'
                          rules={[{ required: true }]}
                        >
                          <Input style={{ width: '100%' }} placeholder='담당자명' />
                        </Form.Item>
                      </Col>
                      <Col span={16}>
                        <Form.Item
                          name={'responsible_email'}
                          className='form-item required-none'
                          label=' '
                          rules={[
                            {
                              type: 'email',
                              message: '이메일 형식이 올바르지 않습니다.',
                            },
                            { required: true },
                          ]}
                        >
                          <Input style={{ width: '100%' }} placeholder='이메일을 입력해 주세요' />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Input.Group>
                )}
                <Form.Item name={'body'} className='form-item' label='내용'>
                  <EditorComponent content='' />
                </Form.Item>
                <div className='form-bottom'>
                  <Form.Item style={{ float: 'right' }}>
                    <Button
                      size='large'
                      type='primary'
                      htmlType='submit'
                      onClick={onClickSubmit}
                      loading={submitButtonDisabled}
                    >
                      제출
                    </Button>
                  </Form.Item>
                </div>
              </Form>
            </FormWrapper>
          </Col>
        </Row>
      </CompanyJobOpeningWrapper>
    </CommonWrapper>
  );
};

export default CompanyJobOpening;
